import localStoragePlugin from 'kea-localstorage'
import sagaPlugin from 'kea-saga'
import { routerPlugin } from 'kea-router'

import dimensionsPlugin from './dimensions'
import initScenePlugin from './init-scene'
import { removeLanguageUrlFromPath, maybeAddLanguageUrlToPath } from 'lib/utils/links'

export default function plugins ({ pathname, search } = {}) {
  let location

  if (pathname) {
    // here we're passing an empty hash and an empty search for server side render to avoid issues with null values using the kea-router version 0.5.3
    location = { pathname, search: typeof window !== 'undefined' ? search : '', hash: '' }
  }

  return [
    localStoragePlugin,
    routerPlugin({
      location,
      pathFromWindowToRoutes: path => removeLanguageUrlFromPath(path),
      pathFromRoutesToWindow: path => maybeAddLanguageUrlToPath(path),
      // support unicode for dynamic url segments
      urlPatternOptions: { segmentValueCharset: 'a-zA-Z0-9-_~ %\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF' }
    }),
    dimensionsPlugin,
    initScenePlugin,
    sagaPlugin
  ]
}
